require('./dict.less');



if (window.location.href.indexOf('/list') !== -1) {
  var forms = window.pageConfig.forms;
  var html = '';
  var itemTemplate = require('./item.html');
  forms.forEach((item) => {
    var data = {
      id: item._id,
      name: window.pageConfig.name,
      title: item.title + ' --- ' + item.type,
      mean: item.mean,
      usages: []
    }
    for (var i = 0; i < 5; i++) {
      var key = 'usage' + (i || '');
      if (item[key]) {
        data.usages.push({
          usage: item[key],
          zh: item['zh' + (i || '')]
        })
      } 
    }
    var div = itemTemplate(data);
    html += div;
  })

  $('body').html(html);
} else if (location.href.indexOf('/edit') !== -1 ) {
  var wrapper = require('./edit.html');
  var href = location.href.split('?')[0];
  href = href.split('/');
  var wid = href[href.length - 1];
  var forms = window.pageConfig.forms;
  var itemData;
  forms.some((item) => {
    if (item._id == wid) {
      itemData = item
      return true;
    }
  });

  $('body').html(wrapper(itemData));
  var form = $('.ui.form');
  form.form({
    fields: {
      title: {
        identifier: 'title',
        rules: [{
          type: 'empty',
          prompt: 'no empty'
        }]
      }
    },
    onSuccess: function(e, data) {
      $.ajax({
        url: location.pathname,
        method: 'POST',
        data: data
      }).done(function(res) {
        if (res.success) {
          window.opener.location.reload();
          window.close();
        }
      });
    }
  });
} else {
  var wrapper = require('./main.html');
  $('body').html(wrapper({
  }));
  $('body').html(wrapper({
    types: ['短语', '单词', '形容词', '及物动词', '不及物动词', '过去式', '现在分词', '第三人称单数', '复数']
  }));
  var form = $('.ui.form');
  form.form({
    fields: {
      name: {
        identifier: 'name',
        rules: [{
          type: 'empty',
          prompt: 'no empty'
        }]
      },
      title: {
        identifier: 'title',
        rules: [{
          type: 'empty',
          prompt: 'no empty'
        }]
      }
    },
    onSuccess: function(e, data) {
      $.ajax({
        url: '/dict/add',
        method: 'POST',
        data: data
      }).done(function(res) {
        if (res.success) {
          form.form('reset');
        }
      });
    }
  });
  $('.dropdown.ui').dropdown({
    onChange: function(value, text) {}
  });
}





// WEBPACK FOOTER //
// ./src/pages/dict/dict.js